import type { Node } from '../../../core/models/scene';

export const PROCESS_STEP_TYPES = new Set(['process', 'flowchart-shape', 'bpmn-shape', 'decision', 'terminator']);

/** Process estimates use minutes; a working day is eight hours. Zero is explicit. */
export function parseProcessDuration(raw: unknown): number | null {
  if (typeof raw === 'number') return Number.isFinite(raw) && raw >= 0 ? raw : null;
  if (typeof raw !== 'string') return null;
  const match = raw.trim().toLowerCase().match(/^(\d+(?:\.\d+)?)\s*(m|min|mins|minute|minutes|h|hr|hrs|hour|hours|d|day|days)?$/);
  if (!match) return null;
  const unit = match[2] ?? 'min';
  const duration = Number(match[1]) * (unit.startsWith('h') ? 60 : unit.startsWith('d') ? 480 : 1);
  return Number.isFinite(duration) ? duration : null;
}

export function getProcessStepDuration(node: Node): number | null {
  return parseProcessDuration(node.attrs?.duration ?? node.props?.duration);
}
